import React from "react";

const contactSupport = <a href="mailto: support@mailchannels.com">support@mailchannels.com</a>;

export { contactSupport };
